import { addListener } from "./support/utils";

class BRCarouselStatic
{
    static carouselStaticInstances = new Map();

    constructor(sliderElement, options={})
    {
        if (sliderElement && BRCarouselStatic.getInstance(sliderElement) === undefined ) {
            this.brCarousel = sliderElement;
            this.brCarouselParent = sliderElement.parentElement;

            const htmlOptions = {};
            const data = this.brCarousel.dataset;

            Object.keys(data).forEach(key => {
                if ( key.startsWith('brCarouselStatic') ) {
                    const optionName = key.replace('brCarouselStatic', '')
                        .replace(/^\w/, c => c.toLowerCase() );
                    htmlOptions[optionName] = data[key];
                }
            })

            // Default options
            this.options = {
                trigger: 'click', // none, hover, click
                ...htmlOptions,
                ...options
            }

            this.brCarouselChildren = this.brCarousel.querySelectorAll('[data-br-carousel-static-item]');

            this.init();
        }
    }

    init()
    {
        this.slideIndex = 0;
        this.prevTranslate = 0;
        this.prevBtn = this.brCarouselParent.querySelector(".prev-button");
        this.nextBtn = this.brCarouselParent.querySelector(".next-button");

        this.setIndicators();

        this.setListeners();
    }

    setIndicators()
    {
        // Clear the extra slide indicators if we end up with too many.
        this.brCarouselParent.querySelector(".itemIndicators").innerHTML = '';
        this.totalSlideCount = this.brCarouselChildren.length;

        // Generate the indicators and render them on screen.
        for ( let i= 0; i < this.totalSlideCount; i++ ) {
            const indicator = document.createElement("span");
            indicator.className = "cIndicator cursor-pointer";
            indicator.innerHTML = `
<svg width="21" height="8" viewBox="0 0 21 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect opacity="0.15" x="0.289062" width="21" height="4" fill="#2A2F33"/>
</svg>
`;
            if ( i === this.slideIndex ) {
                indicator.children[0].children[0].setAttribute("opacity", "1");
            }
            else {
                this.brCarouselChildren[i].style.display = 'none';
            }

            this.brCarouselParent.querySelector(".itemIndicators").appendChild(indicator);

            // Add listener so the user can click the indicator and cause the carousel to scroll
            addListener('click', indicator, () => this.slide( i ));
        }

        this.indicators = this.brCarouselParent.querySelectorAll(".cIndicator");
    }

    setListeners()
    {
        // Set the listeners connected to this carousel
        addListener('resize', window, this.setIndicators);

        // Touch event listeners
        addListener('touchstart', this.brCarousel, (evt) => this.touchStart(evt));
        addListener('touchmove', this.brCarousel, (evt) => this.touchMove(evt));
        addListener('touchend', this.brCarousel, (evt) => this.touchEnd(evt));

        // Mouse wheel event listener
        addListener('wheel', this.brCarousel, (evt) => this.#handleWheel(evt));

        // Mouse event listeners
        addListener('mousedown', this.brCarousel, (evt) => this.mouseStart(evt));
        addListener('mousemove', this.brCarousel, (evt) => this.mouseMove(evt));
        addListener('mouseup', this.brCarousel, (evt) => this.mouseEnd(evt));
        addListener('click', this.brCarousel, (evt) => this.setLightbox(evt), null, true);
        addListener('mouseleave', this.brCarousel, (evt) => this.mouseEnd(evt));

        addListener('click', this.prevBtn, () => this.slide( -1));
        addListener('click', this.nextBtn, () => this.slide( 1));
    }

    //############################
    //####  Touch gestures  ######
    //############################
    touchStart(event)
    {
        this.startPosX = this.getPositionX(event);
        this.startPosY = this.getPositionY(event);
        this.animationID = requestAnimationFrame(() => this.animation());
        this.brCarousel.classList.add('cursor-grabbing');
    }

    touchMove(event) {
        if (event.touches.length > 0) {
            const currentPositionX = this.getPositionX(event);
            const currentPositionY = this.getPositionY(event);

            const diffX = Math.abs(currentPositionX - this.startPosX);
            const diffY = Math.abs(currentPositionY - this.startPosY);

            if (diffX > diffY) {
                this.isDragging = true;
                this.currentTranslate = this.prevTranslate + currentPositionX - this.startPosX;
                this.setSliderPosition();  // Update the position during the touch move
                event.preventDefault();
            }
        }
    }

    touchEnd(event)
    {
        if (this.isDragging) {
            this.stopClick = true;
            this.finalizeMove();
        }
    }

    finalizeMove()
    {
        cancelAnimationFrame(this.animationID);
        this.isDragging = false;
        this.brCarousel.classList.remove('cursor-grabbing');

        // Determine which direction the touch event moved the slides, and set the position
        if ( this.prevTranslate > this.currentTranslate ) {
            this.slide(1)
        }
        else {
            this.slide(-1)
        }

        this.prevTranslate = 0;
        this.currentTranslate = 0;
        this.setSliderPosition();
    }

    //############################
    //####    Mouse wheel   ######
    //############################
    #handleWheel(event) {
        // Only capture if the wheel is spinning horizontally.
        if (Math.abs(event.deltaX) > 0) {
            // Prevent the default scroll behavior to manually handle horizontal scrolling
            event.preventDefault();

            // Adjust the carousel position based on the horizontal scroll amount (deltaX)
            const scrollAmount = event.deltaX;

            if ( scrollAmount > 0 ) {
                this.slide(1)
            }
            else if ( scrollAmount < 0 ) {
                this.slide(-1)
            }
        }
    }

    //############################
    //####    Mouse move    ######
    //############################
    mouseStart(event)
    {
        this.startPos = event.clientX;
        this.animationID = requestAnimationFrame(() => this.animation());

        // Prevent text selection
        event.preventDefault();
    }

    mouseMove(event)
    {
        if (event.buttons === 1) {
            this.isDragging = true;
            let currentPosition = event.clientX;
            this.currentTranslate = this.prevTranslate + currentPosition - this.startPos;

            // Prevent text selection
            event.preventDefault();
        }
    }

    mouseEnd(evt)
    {
        if (this.isDragging) {
            // Prevent popup window from opening
            this.stopClick = true;

            // Continue processing
            this.finalizeMove();
        }
    }

    setLightbox(evt)
    {
        if (this.stopClick) {
            evt.preventDefault();
            evt.stopPropagation();

            this.stopClick = false;
        }
    }


    //############################
    //####  Support Methods ######
    //############################
    getPositionX(event)
    {
        return event.touches[0].clientX;
    }

    getPositionY(event) {
        return event.touches[0].clientY;
    }

    animation()
    {
        this.setSliderPosition();
        if (this.isDragging) requestAnimationFrame(() => this.animation());
    }

    setSliderPosition()
    {
        this.brCarousel.style.transform = `translateX(${this.currentTranslate}px)`;
    }

    slide(direction)
    {
        const newIndex = this.slideIndex + direction;
        if ( newIndex >= 0 && newIndex < this.totalSlideCount ) {

            this.brCarouselChildren[this.slideIndex].style.display = 'none';
            this.indicators[this.slideIndex].children[0].children[0].setAttribute("opacity", "0.15");

            this.slideIndex = newIndex;

            this.brCarouselChildren[this.slideIndex].style.display = 'flex';
            this.indicators[this.slideIndex].children[0].children[0].setAttribute("opacity", "1");
        }
    }

    static initAll(parentElement)
    {
        let container = parentElement || document;
        container.querySelectorAll('[data-br-carousel-static]').forEach(slideElement => {
            if (!BRCarouselStatic.carouselStaticInstances.has(slideElement)) {
                new BRCarouselStatic(slideElement);
            }
        });
    }

    static getInstance(slideElement) {
        return BRCarouselStatic.carouselStaticInstances.get(slideElement);
    }
}

export default BRCarouselStatic;